// extracted by mini-css-extract-plugin
module.exports = {"telemetryView":"GenericDevice_telemetryView__2k51a","genericTelemetry":"GenericDevice_genericTelemetry__3irJs"};